import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; // ← getAuth と GoogleAuthProvider をインポート

// Your web app's Firebase configuration
// ※注意: 本番環境ではAPIキーなどを環境変数で管理することを強く推奨します

const firebaseConfig = {
  apiKey: "AIzaSyAIpVCSVO6rrn2qL9ooSeeE0UQ6O-oZuqE",
  authDomain: "himawarin-lab.firebaseapp.com",
  projectId: "himawarin-lab",
  storageBucket: "himawarin-lab.firebasestorage.app",
  messagingSenderId: "534853204805",
  appId: "1:534853204805:web:5e0cc9c579170a36739c2c",
  measurementId: "G-0B026R63R9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase Authentication のインスタンスを取得
const auth = getAuth(app);

// Google認証プロバイダーのインスタンスを作成
const googleProvider = new GoogleAuthProvider();

// auth と provider をエクスポート
export { auth, googleProvider };
